<template>
  <div class="skillTopic assessment-mb backgroundTopic"  :class="{'skillTopicPC':$store.state.innerWidth>768}">
    <div class="topic-pc">
     <div class="topic-content">
        <div class="skillTitle Medium">{{$t('message.Background-Career Quiz')}}</div>
          <div class="questionNo SemiBold center" v-if="$store.state.innerWidth>768">
            {{$t('message.Q')}}{{swiperIndex}}/{{totalRows}}
          </div>
        <div class="relative">
          <div class="paginationGroup">
            <div class="swiper-pagination" slot="pagination">
            </div>
            <div class="paginationImg" >
              <img  src="../images/assessment/assessment-52.png" ref="assessmentImg"/>
            </div>
          </div>
          <div class="questionNo SemiBold center" v-if="$store.state.innerWidth<=768">
            {{$t('message.Q')}}{{swiperIndex}}/{{totalRows}}
          </div>
          
          <swiper :options="swiperOption" class="swiperCarrousel" ref="honorSwiper">
              <swiper-slide class="swiper-slide box-slide swiper-no-swiping">
                  <div class="questionTitle SemiBold center">
                     {{$t('message.Your highest education attained:')}}
                  </div>
                  <div class="educationList row">
                     <div 
                       class="educationGroup col-xs-6 col-sm-4 " 
                       v-for="(education,index) in bgdAssEducationList"
                       >
                       <div class="education" :class="{'selected':educationCode==education.id}" @click="changeEducation(education)">
                          <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(education.langMap)}}</a>
                       </div>
                     </div>
                  </div>
              </swiper-slide>
              <swiper-slide class="swiper-slide box-slide swiper-no-swiping">
                  <div class="questionTitle SemiBold center">
                     {{$t('message.Years of working experience:')}}
                  </div>
                  <div class="questionImage center">
                    <img src="../images/assessment/background-53.png"  />
                  </div>
                  <div class="inputYearGroup">
                    <div class="inputYear">
                       <input type="number" tabindex="-1" max="99" v-bind:placeholder="$t('message.Number')" v-model="minExperience"></input>
                       <span class="SemiBold">{{$t('message.Years')}}</span>
                    </div>
                  </div>
              </swiper-slide>
              <swiper-slide class="swiper-slide box-slide swiper-no-swiping">
                  <div class="questionTitle SemiBold center">
                     {{$t('message.Your field of study:')}}
                  </div>
                  <div class="questionImage center">
                    <img src="../images/assessment/background-54.png"  />
                  </div>
                  <div class="inputStudyGroup">
                    <div class="inputStudy">
                       <input type="text" tabindex="-1" v-bind:placeholder="$t('message.Field of study')" v-model="studyInput"></input>
                       <div class="criteria-content can-scrol show" v-if="studyList.length>0">
                        <div class="ulGroup" >
                          <ul>
                              <li v-for="(study,index) in studyList" :class="{'border':index!=0}" v-html="$store.getters.getObject(study.langMap).showContent" @click="selectStudy(study)">
                              </li>
                          </ul>
                        </div>
                       </div>
                    </div>
                  </div>
                  <div class="noteTip" :class="{'pad-b-100':studyList.length>0}">
                    {{$t('message.studyNote')}}
                  </div>
              </swiper-slide>
              <swiper-slide class="swiper-slide box-slide swiper-no-swiping">
                  <div class="questionTitle SemiBold center">
                     {{$t('message.Your current occupation:')}}
                  </div>
                  <div class="questionImage center">
                    <img src="../images/assessment/background-55.png"  />
                  </div>
                  <div class="inputJobGroup" :class="{'pad-b-230':jobList.length>0}">
                    <div class="inputJob">
                       <input type="text" tabindex="-1" v-bind:placeholder="$t('message.Job title')" v-model="jobTile"></input>
                       <div class="criteria-content can-scrol show" v-if="jobList.length>0">
                        <div class="ulGroup">
                          <ul>
                              <li v-for="(job,index) in jobList" :class="{'border':index!=0}" v-html="job.showTitle"  @click="selecJob(job)">
                              </li>
                          </ul>
                          </div>
                       </div>
                    </div>
                  </div>
              </swiper-slide>
          </swiper>
          <div class="swiper-button-prev"  slot="button-prev">
            <a href="javascript:;" style="color: inherit"><i class="icon-arrow-down"></i></a>
          </div>
          <div class="swiper-button-next" slot="button-next" :class="{'swiper-btn-disabled':swiperIndex==2&&!minExperience||swiperIndex==3&&!(studyInput==''||(studyInput&&fieldsOfStudy))}">
            <a href="javascript:;" style="color: inherit"><i class="icon-arrow-down"></i></a>
          </div>
          <div class="showResultBtn show" role="button" :aria-label="$t('message.Show result')" v-if="educationCode&&minExperience&&swiperIndex==4"  @click="gotoMatches" :class="{'disabled':!(jobTile==''||(jobTile&&relevantCode))}">
            <a href="javascript:;" style="color: inherit">{{$t('message.Show result')}}</a>
          </div>
        </div>
     </div>
     <div class="bgImage">
       <img class="bgImg2 noSelect" src="../images/deco-05.png" />
       <img class="bgImg4 noSelect" src="../images/deco-12.png" />
       <img class="bgImg5 noSelect" src="../images/deco-31.png" />
     </div>
     </div>
  </div>
</template>
<script>
export default {
    data() {
        return {
            swiperOption: {
                pagination: {
                  el: '.swiper-pagination',
                  type: 'progressbar'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                on:{
                  transitionEnd: this.transitionEnd,
                  transitionStart: this.transitionStart,
                },
                autoHeight: true,
            },
            questionList:[],
            occupationsList:[],
            totalRows:4,
            educationCode:1,
            swiperIndex:1,
            answerIndex:0,
            getQuestions:false,
            marks: val => val % 1 === 0,
            bgdAssEducationList:[],
            jobList:[],
            studyList:[],
            fieldsOfStudy:"",
            minExperience:"",
            jobTile:"",
            selectStudyObj:{},
            selectJobObj:{},
            studyInput:"",
            canFilter:true,
            relevantCode:"",
        }
    },   
    components: {
        
    },
    created(){
    },
    props: ["logGaEvent"],
    computed: {
      __swiper__() {
        return this.$refs.honorSwiper.swiper
      },
      _language(){
        return this.$store.state.language
      }
    },
    methods: {
      init:function(){
        var that = this;
        this.api.getBgdAssEducationList({
        }, function(data) {
            that.$set(that, "bgdAssEducationList", data.result);
            that.educationCode = that.bgdAssEducationList[0].id;
            that.transitionStart()
        })
      },
      transitionEnd:function(){
        this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        if(this.__swiper__.activeIndex>this.answerIndex){
          this.answerIndex = this.__swiper__.activeIndex;
        }
          this.logGaEvent('userClick','backgroundTopic-transitionEnd',this.swiperIndex)
      },
      transitionStart:function(){

        this.studyList=[];
        this.jobList=[];
        if(this.$store.state.innerWidth>840){
          var w = 840 - 70;
        }else{
          var w = this.$store.state.innerWidth - 70;
        }
        
        this.$set(this, "swiperIndex", this.__swiper__.activeIndex+1);
        if(this.__swiper__.activeIndex>this.answerIndex){
          this.answerIndex = this.__swiper__.activeIndex;
        }
        var left = w/this.totalRows*(this.__swiper__.activeIndex+1) -5;
        this.$refs.assessmentImg.style.transform = "translate3d("+ left +"px, 0px, 0px) "
      },
      changeEducation:function(obj){
        this.educationCode = obj.id;
      },
      gotoMatches:function(){
        if(!(this.jobTile==''||(this.jobTile&&this.relevantCode))){
          return;
        }
          this.$store.state.formData.scoreData = {
            "experience":this.minExperience,
            "educationCode":this.educationCode,
            "relevantCode":this.relevantCode,
            "fieldsOfStudyCode":this.fieldsOfStudy,
          };
          this.$store.state.formData.scoreType = 3;
          this.logGaEvent('userClick','backgroundTopic-gotoMatches',this.swiperIndex)
          this.$router.push({ path: '/careerMatches/', query:{lang:this.$store.state.language} });
           window.scrollTo(0, 0);
      },
      findBgdAssTitleByTitle:function(){
        var that = this;
        this.relevantCode=""
        this.api.findBgdAssTitleByTitle({
          "title": this.jobTile,
        }, function(data) {
          for(var i=0;i<data.result.length;i++){
            var lTitle = data.result[i].title.toLowerCase().split(that.jobTile.toLowerCase());
            var no=0;
            var str = "";
            for(var j=0;j<lTitle.length;j++){
              var a = data.result[i].title.substring(no,no+lTitle[j].length);
              no = no+lTitle[j].length;
              str+=a;
              var b = data.result[i].title.substring(no,no+that.jobTile.length);
              b="<span class='Bold'>"+b+"</span>"
              no +=that.jobTile.length;
              str+=b
            }
            data.result[i].showTitle = str;
          }
       
          that.$set(that, "jobList", data.result);
        })
      },
      getBgdAssFieldOfStudy:function(){
        var that = this;
        this.fieldsOfStudy=""
        this.api.getBgdAssFieldOfStudy({
          "title": this.studyInput 
        }, function(data) {
          for(var i=0;i<data.result.length;i++){
            for(var k=0;k<data.result[i].langMap.length;k++){
              var lTitle = data.result[i].langMap[k].content.toLowerCase().split(that.studyInput.toLowerCase());
              var no=0;
              var str = "";
              for(var j=0;j<lTitle.length;j++){
                var a = data.result[i].langMap[k].content.substring(no,no+lTitle[j].length);
                no = no+lTitle[j].length;
                str+=a;
                var b = data.result[i].langMap[k].content.substring(no,no+that.studyInput.length);
                b="<span class='Bold'>"+b+"</span>"
                no +=that.studyInput.length;
                str+=b
              }
              data.result[i].langMap[k].showContent = str;
            }
          }
            that.$set(that, "studyList", data.result); 
        })
      },
      selectStudy:function(item){
        this.canFilter = false;
        this.fieldsOfStudy = item.id;
        this.selectStudyObj = item;
        this.studyInput = this.$store.getters.getContent(item.langMap);
        this.studyList=[];
      },
      selecJob:function(item){
        this.canFilter = false;
        this.jobTile = item.title;
        this.relevantCode = item.code;
        this.jobList=[];
      }
    },
    mounted() {
      this.$store.state.selectMenu =5;
      this.$store.state.formData.scoreData = [];
      this.$store.state.formData.scoreType = 0;
        this.$store.state.mate.title = this.$i18n.t("message.Self-Assessment")+" - talent.gov.hk"
      this.init()
    },
    watch:{
      jobTile: {
        handler: function(val, oldVal) {
          if(this.jobTile&&this.canFilter){
            this.findBgdAssTitleByTitle();
          }else{
            this.jobList = [];
          }
          this.canFilter = true;
        },
        deep: true
      },
      studyInput: {
        handler: function(val, oldVal) {
          if(this.studyInput&&this.canFilter){
            this.getBgdAssFieldOfStudy();
          }else{
            this.studyList = [];
          }
          this.canFilter = true;
        },
        deep: true
      },
      minExperience: {
        handler: function(val, oldVal) {
          if(val>99||val<0||val.indexOf('.')!=-1){
            this.minExperience = oldVal;
          }
        },
        deep: true
      },
      _language:{
        handler: function(val, oldVal) {
          this.studyInput = this.$store.getters.getContent(this.selectStudyObj.langMap);
        },
        deep: true
      }
    }
}
</script>